import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
export function DespreStory() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1238">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1239">
        <SectionHeading title="De ce am creat Academia de Abundență" data-id="element-1240" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg text-brand-text/85 leading-relaxed" data-id="element-1241">
          <p data-id="element-1242">
            Mulți oameni pe care îi întâlnesc funcționează bine în exterior. Au
            un job, au o familie, au o viață care arată "ok" pe hârtie. Dar în
            interior simt un gol, un stres pe care nu și-l explică, o relație
            dificilă cu banii sau sentimentul că viața lor poate fi mult mai
            bună decât este acum.
          </p>

          <div className="my-12 p-8 md:p-10 bg-brand-cream rounded-3xl border-l-4 border-brand-gold relative" data-id="element-1243">
            <span className="absolute -top-4 -left-4 w-12 h-12 bg-brand-gold rounded-full flex items-center justify-center text-white font-heading font-bold text-2xl shadow-warm" data-id="element-1244">
              "
            </span>
            <p className="font-subtitle italic text-xl md:text-2xl text-brand-text leading-relaxed" data-id="element-1245">
              Când ai multă informație, dar nu ai pe cineva care să te ghideze
              pas cu pas, totul rămâne la nivel de teorie. Și viața ta continuă
              cu aceleași tipare.
            </p>
          </div>

          <p data-id="element-1246">
            Am creat Academia de Abundență exact pentru asta. Un loc în care
            oamenii nu doar învață, ci și practică. În care primesc ghidare
            reală, meditații, exerciții și susținere constantă. Pentru că
            transformarea nu vine din a citi încă o carte, ci din a avea pe
            cineva care te ține de mână pe drum.
          </p>
        </motion.div>
      </div>
    </section>;
}